// src/components/ConnectWallet.js
import React, { useEffect, useState } from 'react';
import { useAccount } from 'wagmi';
export default function ConnectWallet({ onConnect, onDisconnect }) {
  const [mounted, setMounted] = useState(false);
  const { isConnected } = useAccount();

  // Track component mount for hydration
  useEffect(() => {
    setMounted(true);
  }, []);

  // Fire onConnect / onDisconnect when wallet status changes
  useEffect(() => {
    if (!mounted) return;
    if (isConnected) {
      onConnect?.();
    } else {
      onDisconnect?.();
    }
  }, [isConnected, mounted, onConnect, onDisconnect]);

  if (!mounted) return null;

  return (
    <div>
      <w3m-button />
    </div>
  );
}
